import api from './api';

export default async function deleteTest(test_id) {
    const { data } = await api.delete(`tests/${test_id}`);
    return data;
}